import TurndownService from 'turndown';

// Converts legacy HTML content to Markdown when an old record is opened for editing.
// This keeps the editor showing clean Markdown (not raw HTML tags) AND ensures the
// saved body is Markdown — so editing a legacy project doesn't re-send HTML and trip
// the WAF. Content that is already Markdown/plain text is returned unchanged.
const turndown = new TurndownService({
    headingStyle: 'atx',
    codeBlockStyle: 'fenced',
    bulletListMarker: '-',
});

const looksLikeHtml = (s) => typeof s === 'string' && /<([a-z][\s\S]*?)>/i.test(s);

export const htmlToMarkdown = (value = '') =>
    looksLikeHtml(value) ? turndown.turndown(value).trim() : (value || '');

export default htmlToMarkdown;
